import { useState } from "react";

export const SummaryForm = (props) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [termsConsented, setTermsConsented] = useState(false);
  const [sendingInProgress, setSendingInProgress] = useState(false);

  return (
    <div className="row" style={{ marginTop: 22 }}>
      <div className="col-lg-6 first-form" style={{ marginLeft: "25%" }}>
        <form
          className="form-horizontal"
          id="_form_570_"
          onSubmit={handleSubmit}
        >
          <div className="form-group">
            <label
              htmlFor="inputName"
              className="control-label col-md-4 required attribute_label"
            >
              <abbr title="Povinné pole">*</abbr> Jméno a příjmení
            </label>
            <div className="col-md-7">
              <input
                className="form-control"
                id="inputName"
                name="inputName"
                placeholder="Jan Novák"
                required
                value={name}
                onChange={handleNameChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label
              htmlFor="inputEmail"
              className="control-label col-md-4 required attribute_label"
            >
              <abbr title="Povinné pole">*</abbr> Váš e-mail
            </label>
            <div className="col-md-7">
              <input
                type="email"
                className="form-control"
                id="inputEmail"
                name="inputEmail"
                placeholder="jan.novak@seznam.cz"
                value={email}
                required
                onChange={handleEmailChange}
              />
            </div>
          </div>
          <div className="form-group">
            <div className="col-md-4"></div>
            <div
              className="col-md-1"
              style={{
                textAlign: "left",
                paddingTop: 5,
                marginRight: -10,
              }}
            >
              <input
                className="boolean optional"
                type="checkbox"
                name="inputTerms"
                id="inputTerms"
                required="true"
              />
            </div>
            <label
              className="control-label col-md-6 required attribute_label"
              htmlFor="inputTerms"
              style={{
                textAlign: "left",
                fontWeight: "normal",
                paddingLeft: 0,
              }}
            >
              Souhlasím se{" "}
              <a
                data-modal-title=""
                data-modal-remote-url="/dokumenty/gdpr-souhla-se-zpracovanim-osobnich-udaju-a-informace-o-zpracovani-osobnich-udaju.modal"
                className=""
                href="/dokumenty/gdpr-souhla-se-zpracovanim-osobnich-udaju-a-informace-o-zpracovani-osobnich-udaju/"
                target="_blank"
              >
                zpracováním osobních údajů
              </a>{" "}
              potřebných pro zasílání e-mailu od Spořílek.cz
            </label>
          </div>
          <div className="form-group">
            <div className="col-md-offset-4 col-md-7">
              <input
                type="submit"
                value={sendingInProgress ? "Odesílám..." : "Odeslat"}
                className="button button-primary larger-text"
                disabled={formDisabled()}
                style={{ fontWeight: "bold" }}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );

  function handleEmailChange(e) {
    setEmail(e.target.value);
  }

  function handleNameChange(e) {
    setName(e.target.value);
  }

  function formDisabled() {
    return sendingInProgress;
  }

  function handleSubmit(e) {
    setSendingInProgress(true);
    e.preventDefault();

    $.post(
      "/tvorba-setu-spotrebicu/finish",
      {
        email: email,
        name: name,
        total_price: props.discountedTotalPrice,
        total_price_without_discount: props.totalPrice,
      },
      function (data) {
        const url =
          "http://" +
          document.location.hostname +
          "/tvorba-setu/moznosti/" +
          data.token;
        window.location.href = url;
      }.bind(this)
    );
  }
};
